import { render, staticRenderFns } from "./CreateTeacher.vue?vue&type=template&id=31b72614&scoped=true&lang=true&"
import script from "./CreateTeacher.vue?vue&type=script&lang=js&"
export * from "./CreateTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b72614",
  null
  
)

export default component.exports